<template>
  <div>
    <b-card no-header>
      
      <b-row>
          <b-col cols="12" md="12">
            <template
              v-for="(m, index) in filterModel([
                'kode_kegiatan_id',
                'uraian_kegiatan',
                // 'nama_kegiatan',
                'account_code_id',
              ])"
            >
              <div :key="index">
                <detail-group-input
                  :ref="index"
                  :type="m.type"
                  :label="typeof m.label === 'string' ? m.label : null"
                  :need-label="true"
                  v-model="m.value"
                  :id="index"
                />
              </div>
            </template>
            <b-row>
              <template
                v-for="(m, index) in filterModel([
                  'harga_satuan',
                  'jenis_satuan',
                  'total_harga',
                ])"
              >
                <b-col cols="12" md="4">
                  <div :key="index">
                    <detail-group-input
                      :ref="index"
                      :type="m.type"
                      :label="typeof m.label === 'string' ? m.label : null"
                      :need-label="true"
                      v-model="m.value"
                      :id="index"
                    />
                  </div>
                </b-col>
              </template>
            </b-row>
            <b-row>
              <template
                v-for="(m, index) in filterModel([
                  'volume',
                  'frekuensi',
                  'bulan_kegiatan',
                ])"
              >
                <b-col cols="12" md="4">
                  <div :key="index">
                    <detail-group-input
                      :ref="index"
                      :type="m.type"
                      :label="typeof m.label === 'string' ? m.label : null"
                      :need-label="true"
                      v-model="m.value"
                      :id="index"
                    />
                  </div>
                </b-col>
              </template>
            </b-row>
          </b-col>
        </b-row>
      
      
        <h5>Rencana Belanja</h5>
        <b-row>
          <b-col cols="12">
            <table class="table">
              <tr>
                <th width="15%" class="text-center">Bulan</th>
                <th width="20%" class="text-right">Harga Satuan</th>
                <th width="20%" class="text-center">Jenis Satuan</th>
                <th  width="20%" class="text-right">Total Harga</th>
                <th  width="15%" class="text-center">Volume</th>
                <th  width="15%">Frekuensi</th>
              </tr>
              <tr v-for="(detail, index) in details" :key="index">
                <td class="text-center">
                  {{ $moment(detail.bulan_kegiatan).format('MMMM') }}
                </td>
                <td class="text-right">
                  Rp{{ $formatPrice(detail.harga_satuan) }}
                </td>
                <td class="text-center">
                  {{ detail.jenis_satuan }}
                </td>
                <td class="text-right">
                  Rp{{ $formatPrice(detail.total_harga) }}
                </td>
                <td class="text-center">
                  {{ detail.volume }}
                </td>
                <td>
                  {{ detail.frekuensi ? detail.frekuensi : '-' }}
                </td>
              </tr>
              <tr v-if="model">
                <td colspan="7" align="right">
                  Total Harga <strong>Rp. {{ $formatPrice(total_harga_keseluruhan) }}</strong>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
        
        <form v-if="planning_status === statusRkas.disetujui" @submit.prevent="onSubmit">
          <div >
            <h5>Realisasi Belanja</h5>

            <table class="table">
              <tr>
                <th width="10%">Bulan<span class="text-danger">*</span></th>
                <th width="15%">Harga Satuan<span class="text-danger">*</span></th>
                <th width="15%">Jenis Satuan<span class="text-danger">*</span></th>
                <th  width="15%">Total Harga<span class="text-danger">*</span></th>
                <th  width="15%">Volume<span class="text-danger">*</span></th>
                <th  width="15%">Frekuensi</th>
                <th  width="20%"></th>
              </tr>
              <tr v-for="(detail, index) in details" :key="index">
                <td>
                  {{ $moment(detail.bulan_kegiatan).format('MMMM') }}
                </td>
                <td>
                  <form-group-input
                    :noMarg="true"
                    text-align="right"
                    type="price"
                    label="Harga satuan"
                    v-model="detail.realisasi_harga_satuan"
                    :need-label="false"
                    :rules="'required'"
                    :ref="'realisasi_harga_satuan_' + index"
                    :id="'realisasi_harga_satuan_' + index"
                  />
                </td>
                <td>
                  <form-group-input
                    :noMarg="true"
                    type="text"
                    label="Jenis satuan"
                    v-model="detail.realisasi_jenis_satuan"
                    :need-label="false"
                    :rules="'required'"
                    :ref="'realisasi_jenis_satuan_' + index"
                    :id="'realisasi_jenis_satuan_' + index"
                  />
                </td>
                <td>
                  <form-group-input
                    :noMarg="true"
                    text-align="right"
                    type="price"
                    label="Total Harga"
                    v-model="detail.realisasi_total_harga"
                    :need-label="false"
                    :rules="'required'"
                    :ref="'realisasi_total_harga_' + index"
                    :id="'realisasi_total_harga_' + index"
                  />
                </td>
                <td>
                  <form-group-input
                    :noMarg="true"
                    type="text"
                    label="Volume"
                    v-model="detail.realisasi_volume"
                    :need-label="false"
                    :rules="'required'"
                    :ref="'realisasi_volume_' + index"
                    :id="'realisasi_volume_' + index"
                  />
                </td>
                <td >
                  <form-group-input
                    :noMarg="true"
                    type="text"
                    label="Frekuensi"
                    v-model="detail.realisasi_frekuensi"
                    :need-label="false"
                    :rules="null"
                    :ref="'realisasi_frekuensi_' + index"
                    :id="'realisasi_frekuensi_' + index"
                  />
                </td>
                <td class="text-center">
                  <b-row v-if="detail.school_file_asset_id" class="justify-content-center">
                    <b-button size="small" class="mr-2" variant="info" @click.prevent="openFilePreview(detail.school_file_asset_id)">
                      <font-awesome-icon icon="search-plus"></font-awesome-icon>
                    </b-button>
                    <b-button size="small" variant="danger" @click.prevent="detail.school_file_asset_id = null">
                      <font-awesome-icon icon="sync-alt"></font-awesome-icon>
                    </b-button>
                  </b-row>
                  <b-button v-else size="small" variant="info" @click.prevent="openFileModel(detail.id)">
                    <font-awesome-icon icon="search"></font-awesome-icon> Pilih Bukti
                  </b-button>
                </td>
              </tr>
              <!-- <tr>
                <td colspan="7" align="right">
                  Total Harga Rp. {{ $formatPrice(sumAllTotalHarga) }}
                </td>
              </tr> -->
            </table>
          </div>
          <div>
            <b-button type="submit" variant="primary" class="mt-0"
              ><font-awesome-icon
                icon="spinner"
                spin
                v-if="isLoading"
              ></font-awesome-icon>
              Simpan</b-button
            >
            <b-button
              :to="'/realisasi'"
              variant="secondary"
              class="ml-3 float-right"
              ><font-awesome-icon
                icon="spinner"
                spin
                v-if="isLoading"
              ></font-awesome-icon>
              Batal</b-button
            >
          </div>
        </form>
        <div v-else>
          <b-button
            v-show="planning_status === statusRkas.revisi"
            :to="'/rencana/' + $route.params.id + '/edit'"
            variant="primary"
            class="mt-0 mr-1"
            >Ubah</b-button
          >
          <b-button
            v-show="planning_status === statusRkas.revisi || planning_status === statusRkas.verifikasi"
            @click.prevent="doDelete($route.params.id)"
            variant="danger"
            class="mt-0"
            >Hapus</b-button
          >
        <b-button :to="'/rencana/'" variant="secondary" class="ml-3 float-right"
          >Kembali</b-button
        >
      </div>
    </b-card>
    <fileManagerPopUp ref="fileManagerPopUp" @selected="onFileSelected" />
  </div>
</template>

<script>
import fileManagerPopUp from '@/components/FileManagerPopUp.vue';
import formGroupInput from "@/components/FormGroupInput.vue";
import { setModelValue, cleanIdrFormat, statusRkas } from "@/_helpers";
import detailGroupInput from "@/components/DetailGroupInput.vue";
import Rekening from "@/models/Rekening.js";
import KodeKegiatan from "@/models/KodeKegiatan.js";
import Planning from "@/models/Planning.js";

const model = new Planning();
const rekeningModel = new Rekening();
const kodeKegiatanModel = new KodeKegiatan();

export default {
  components: {
    formGroupInput,
    detailGroupInput,
    fileManagerPopUp
  },
  watch: {
    "$route.params.id": function (val) {
      if (val !== undefined) {
        this.getDetail();
      }
    }
  },
  data() {
    return {
      isLoading: false,
      statusRkas: statusRkas(),
      model: model.init(),
      planning_status: null,
      total_harga_keseluruhan: 0,
      details: []
    };
  },
  mounted() {
    this.getDetail();
  },
  computed: {
    // sumTotalRencanaBelanja: function () {
    //   return this.details.reduce((accumuator, value) => {
    //     return accumuator + this.$priceToInt(value.total_harga)
    //   }, 0)
    // }
  },
  methods: {
    openFilePreview (id) {
      window.open('/file-preview/' + id, '_blank', 'toolbar=0,location=0,menubar=0')
    },
    onFileSelected (resp) {
      const filtered = this.details.filter(detail => {
        return detail.id === resp.idParent
      })
      if (filtered.length > 0) {
        filtered[0].school_file_asset_id = resp.fileId
        // 9ac1a0a6-fb81-416c-93ee-c9a9ccbdbf40
      }
    },
    openFileModel (id) {
      this.$refs.fileManagerPopUp.show(id)
    },
    filterModel(search) {
      const filtered = Object.entries(this.model).filter((mdl) => {
        return search.includes(mdl[0]);
      });
      let result = {};
      filtered.forEach((element) => {
        result[element[0]] = element[1];
      });
      return result;
    },
    async doDelete(id) {
      try {
        this.$swal.fire({
            title: 'Anda Yakin?',
            text: 'Data tidak akan dapat dikembalikan lagi!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak',
            // confirmButtonClass: 'btn btn-danger mr-3',
            // cancelButtonClass: 'btn btn-default',
            // buttonsStyling: false
          }).then(result => {
            if (result.value) {
              let resp = model.delete(id);
              this.$router.push('/rencana');
              // this.$http.post((this.deleteUrl !== null ? this.deleteUrl : this.dataUrl) + '/' + id, {
              //   _method: 'DELETE'
              // }).then(response => {
                this.$store.dispatch('notification/success', 'Berhasil menghapus.')
                // this.getDataTable()
                // this.$emit('afterDeleteData', id)
              // }).catch(error => {
              //   this.$store.dispatch('notification/error', 'Gagal menghapus data.')
              //   console.log(error)
              // })
            }
          })
      } catch (error) {
        
      }
    },
    async getDetail() {
      this.isLoading = true;
      try {
        let resp = await model.find(this.$route.params.id, {
          need_detail: 1
        });

        const respAccountCode = await rekeningModel.find(resp.account_code_id);
        resp.account_code_id = respAccountCode.code + ' - ' + respAccountCode.name;

        const respKodeKegiatan = await kodeKegiatanModel.find(resp.kode_kegiatan_id);
        resp.kode_kegiatan_id = respKodeKegiatan.code + ' - ' + respKodeKegiatan.name;

        setModelValue(this.model, resp);
        this.planning_status = resp.status
        this.details = resp.details;
        this.total_harga_keseluruhan = resp.total_harga_keseluruhan

        this.details.forEach((detail, index) => {
          detail.realisasi_harga_satuan = this.$formatPrice(detail.realisasi_harga_satuan ? detail.realisasi_harga_satuan : detail.harga_satuan);
          detail.realisasi_total_harga = this.$formatPrice(detail.realisasi_total_harga ? detail.realisasi_total_harga : detail.total_harga);
          detail.realisasi_jenis_satuan = detail.realisasi_jenis_satuan ? detail.realisasi_jenis_satuan : detail.jenis_satuan;
          detail.realisasi_volume = detail.realisasi_volume ? detail.realisasi_volume : detail.volume;
          detail.realisasi_frekuensi = detail.realisasi_frekuensi ? detail.realisasi_frekuensi : detail.frekuensi;
        });
        this.isLoading = false;
      } catch (error) {

        if (process.env.NODE_ENV !== "production") {
          console.error(error);
        }
        this.isLoading = false;
      }
      // model
      //   .find(this.$route.params.id).then((resp) => {
      //     console.log(resp)
      //     rekeningModel.find(resp.account_code_id).then((respAccountCode) => {
      //       resp.account_code_id = respAccountCode.code + ' - ' + respAccountCode.name
      //     }).catch((error) => {
      //       if (process.env.NODE_ENV !== "production") {
      //         console.error(error);
      //       }
      //       this.isLoading = false;
      //     });
      //     kodeKegiatanModel.find(resp.kode_kegiatan_id).then((respAccountCode) => {
      //       resp.kode_kegiatan_id = respAccountCode.code + ' - ' + respAccountCode.name
      //     }).catch((error) => {
      //       if (process.env.NODE_ENV !== "production") {
      //         console.error(error);
      //       }
      //       this.isLoading = false;
      //     });
      //     setModelValue(this.model, resp);
      //   }).catch((error) => {
      //     if (process.env.NODE_ENV !== "production") {
      //       console.error(error);
      //     }
      //     this.isLoading = false;
      //   });
    },
    onSubmit() {
      // this.$refs.form.validate().then((success) => {
      //   if (!success || this.isLoading) {
      //     scrollToError(this.$refs.form);
      //     return false;
      //   }

        const formDetail = [];
        let errorCount = 0;
        this.details.forEach(detail => {
          if (detail.realisasi_harga_satuan === null || detail.realisasi_harga_satuan === '') {
            this.$store.dispatch("notification/error", 'Realisasi harga satuan wajib diisi');
            errorCount = 1
            return false;
          } else if (detail.realisasi_total_harga === null || detail.realisasi_total_harga === '') {
            this.$store.dispatch("notification/error", 'Realisasi total harga wajib diisi');
            errorCount = 1
            return false;
          } else if (detail.realisasi_jenis_satuan === null || detail.realisasi_jenis_satuan === '') {
            this.$store.dispatch("notification/error", 'Realisasi jenis satuan wajib diisi');
            errorCount = 1
            return false;
          } else if (detail.realisasi_volume === null || detail.realisasi_volume === '') {
            this.$store.dispatch("notification/error", 'Realisasi volume wajib diisi');
            errorCount = 1
            return false;
          } else if (detail.school_file_asset_id === null || detail.school_file_asset_id === '') {
            this.$store.dispatch("notification/error", 'Bukti wajib diisi');
            errorCount = 1
            return false;
          }
          formDetail.push({
            bulan_kegiatan: this.$moment(detail.bulan_kegiatan).format('MM-DD'),
            realisasi_harga_satuan: cleanIdrFormat(detail.realisasi_harga_satuan),
            realisasi_total_harga: cleanIdrFormat(detail.realisasi_total_harga),
            realisasi_jenis_satuan: detail.realisasi_jenis_satuan,
            realisasi_volume: detail.realisasi_volume,
            realisasi_frekuensi: detail.realisasi_frekuensi,
            school_file_asset_id: detail.school_file_asset_id,
          })
        });
        if (!errorCount) {
          this.isLoading = true;
          model.updateRealisasi(this.$route.params.id, formDetail).then(() => {
            this.isLoading = false;
            this.$store.dispatch(
              "notification/success",
              "Data realisasi berhasil disimpan."
            );
            this.$router.push("/realisasi");
          })
          .catch((error) => {
            this.isLoading = false;
            this.$store.dispatch("notification/error", error);
          });
        }
      // });
    },
  },
};
</script>